<template>
  <vs-popup class="add-additional-cost-popup"
            id="popup"
            :title="`ADD ADDITIONAL COST (${product_order_code})`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createForm.name"   name="name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="amount" name="amount" rules="required" v-slot="{ errors }">
                <small class="label">Amount</small>
                <vs-input v-model="createForm.amount"   name="amount" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const StaffRepository = RepositoryFactory.get('staff')
  const CustomerRepository = RepositoryFactory.get('customer')


  function initialState() {
    return {
      open: false,
      id: '',
      exists_additional_cost: [],
      product_order_code: '',
      invoice_date: '',
      createForm: {},
    }
  }

export default {
  name: 'AddAdditionalCostPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, product_order_code, invoice_date, additional_cost) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        this.product_order_code = product_order_code
        this.invoice_date = invoice_date
        Object.assign(this.exists_additional_cost, additional_cost)
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         const payload = {}
         payload.additional_cost = this.exists_additional_cost
         this.createForm.amount = Number(this.createForm.amount).toFixed(2)
         payload.additional_cost.push(this.createForm)
         payload.invoice_date = this.invoice_date
         await CustomerRepository.addAdditionalCostToProductOrder(this.id, payload)
         this.showSuccessMessage('Additional cost added successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .add-additional-cost-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }
</style>
